import { createContext } from 'react';

export const LoungeContext = createContext(null);
